import {createSlice} from '@reduxjs/toolkit';
import {promisePostSimple} from "./fetch";

export const pollSlice = createSlice({
  name: 'poll',
  initialState: {
    newPolls: [],
    passedPolls: [],
    educationList: [],
    pollId: null,
    educationId: null,
  },
  reducers: {
    setNewPolls: (state, {payload}) => {
      state.newPolls = payload
    },
    setPassedPolls: (state, {payload}) => {
      state.passedPolls = payload
    },
    setEducationList: (state, {payload}) => {
      state.educationList = payload
    },
    setPollId: (state, {pollId}) => {
      state.pollId = pollId
    },
    setEducationId: (state, {educationId}) => {
      state.educationId = educationId
    }
  },
});

export const pollSelector = state => state.poll;

export const {setNewPolls, setPassedPolls, setEducationList, setPollId, setEducationId} = pollSlice.actions;

export const getNewPolls = () => {
  return async dispatch => {
    const data =  await dispatch(promisePostSimple('api/polls/newPolls' ));
    dispatch(setNewPolls(data));
  }
};

export const getPassedPolls = () => {
  return async dispatch => {
    const data =  await dispatch(promisePostSimple('api/polls/passedPolls' ));
    dispatch(setPassedPolls(data));
    return data;
  }
};


export const getEducationList = (pollId) => {
  return async dispatch => {
    const data =  await dispatch(promisePostSimple('api/polls/educations', {pollId} ));
    dispatch(setEducationList(data));
    return data;
  }
};

export const getPollContent = (pollId, educationId, isForView) => {
  return async dispatch => {
    return await dispatch(promisePostSimple('api/polls/pollContent', {pollId, educationId, isForView} ));
  }
};

export const savePollAnswers = (pollId, educationId, pollAnswers) => {
  return async dispatch => {
    return await dispatch(promisePostSimple('api/polls/pollAnswersSave', {pollId, educationId, pollAnswers} ));
  }
};

export default pollSlice.reducer;